import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';

@Component({
    selector: '[app-footer]',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <img src="/layout/images/logo-{{ isDarkTheme() ? 'white' : 'dark' }}.svg" alt="diamond-layout" />
                <span class="footer-app-name">MARK ERP</span>
            </div>
            <span class="footer-copyright">&#169; Todos os direitos reservados - {{year}}</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);
    year = new Date().getFullYear()
    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
